import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../../components/tables/tableContext/TableContext";
import { ScannedPackagesFromBinDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../../utils/dateAndTime";

export const scannedPackagesFromBinTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. expeditie",
    value: "doc_trans",
    minW: 125,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 125,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 125,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Nod-Curent",
    value: "nodCurent",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
  },
];

export const getScannedPackagesFromBinTableHeaderTableData = (
  data: ScannedPackagesFromBinDataInterface[],
): TableData[] =>
  data.map((item) => {
    const getCurrentNodeDescription = (withProblems: string | undefined) => {
      if (withProblems === "wrongNode") {
        return item.nodCurent;
      }
      if (withProblems === "notScanned") {
        return "-";
      }
      return "In nod destinatie";
    };

    const getCurrentNodeColor = (withProblems: string | undefined) => {
      if (withProblems === "wrongNode") {
        return "light-danger";
      }
      if (withProblems === "notScanned") {
        return "light-danger";
      }
      return "light-primary";
    };

    return {
      id: item.id_doctrans_detl,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
        },
        {
          title: item.client,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          badges: [
            {
              badgeText: getCurrentNodeDescription(item.withProblems),
              badgeColor: getCurrentNodeColor(item.withProblems),
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.nodDestinatie,
              badgeColor: "light-primary",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
